<script lang="ts">
  import { TableClientSide } from '$lib/components/table';
  import { TextCopy } from '$lib/components/text';
  import type { MemberDto } from '$lib/features/bff/sdk';
  import { formatDate } from '$lib/features/format';
  import { PersonTableCell, PersonChipType } from '$lib/features/person';

  /** Required */
  export let members: MemberDto[];

  $: hasAgent = members.some((m) => m.agent);

  $: members.sort((a, b) => {
    a.person.name.localeCompare(b.person.name);

    // 1. Sort by `type` ascending
    const typeComparison = a.person.type.localeCompare(b.person.type);

    if (typeComparison !== 0) {
      return typeComparison;
    }

    // 2. Sort by `person.name` ascending
    return a.person.name.localeCompare(b.person.name);
  });
</script>

{#if members.length > 0}
  <TableClientSide
    width={hasAgent ? 'max-w-[820px]' : 'max-w-[540px]'}
    limit={members.length > 7 ? 7 : members.length}
    searchable={members.length > 7}
    pageable={members.length > 7}
    searchNested
    headers={hasAgent ? ['Tipo', 'Sócio', 'Representante', 'Entrada'] : ['Tipo', 'Sócio', 'Entrada']}
    headerWidths={hasAgent ? ['min-w-20', 'min-w-80', 'min-w-72', 'w-full'] : ['min-w-20', 'min-w-80', 'w-full']}
    searchPlaceholder="Refinar sócio ou qualificação"
    placeholderHeight="h-[60px]"
    dataset={members}
    let:records
  >
    {#each records as m}
      <tr>
        <!-- Member Type -->
        <td class="!text-center">
          <PersonChipType type={m.person.type} />
        </td>

        <!-- Member Person -->
        <td>
          <PersonTableCell person={m.person} />
          <br />
          <span class="text-surface-600-300-token text-xs">
            <TextCopy value={String(m.role.id)} /> - <TextCopy value={m.role.text} />
          </span>
        </td>

        {#if hasAgent}
          <!-- Member Agent Person -->
          <td>
            {#if m.agent}
              <PersonTableCell person={m.agent.person} />
              <br />
              <span class="text-surface-600-300-token text-xs">
                <TextCopy value={String(m.agent.role.id)} /> - <TextCopy value={m.agent.role.text} />
              </span>
            {:else}
              <span class="text-surface-600-300-token text-xs">-</span>
            {/if}
          </td>
        {/if}

        <!-- Member Since -->
        <td class="!text-center">
          <TextCopy value={formatDate(m.since)} />
        </td>
      </tr>
    {/each}
  </TableClientSide>
{:else}
  <p class="text-surface-600-300-token">A empresa não possui sócios.</p>
{/if}
